// extracted by mini-css-extract-plugin
module.exports = {"root":"ChessCardsTabs_root__2S3tu","chessCard":"ChessCardsTabs_chessCard__174hy"};